import { app } from "@/main";

class AuthService {
  // request token to access Obsidian API
  private getApiAuthTokenAsync = async (
    queryParams: string,
    referrer: string
  ) => {
    const tokenRequest = {
      host: referrer
    };
    const tokenResponse = await app.$axios.post(
      `/auth/generate-token${queryParams}`,
      tokenRequest
    );
    return tokenResponse.data;
  };

  public requestApiTokenAsync = async (
    queryParams: string,
    referer: string
  ) => {
    const token = await this.getApiAuthTokenAsync(queryParams, referer);
    return token;
  };

  // obtains prod & test sites a customer is authorized to access
  private getSitesAsync = async () => {
    const results = await app.$axios.get(`/analytics/sites`);
    return results.data;
  };

  public loadSitesAsync = async () => {
    const sites = await this.getSitesAsync();
    const customerList = sites.map((site: string) => {
      const normalizedValue = site.replace("_TEST", "").replace(/_/g, " ");
      const label =
        site.indexOf("_TEST") < 0
          ? normalizedValue
              .charAt(0)
              .concat(
                `${normalizedValue.substring(1).toLowerCase()} - Production`
              )
          : normalizedValue
              .charAt(0)
              .concat(`${normalizedValue.substring(1).toLowerCase()} - Test`);

      return {
        value: `${site}`,
        label: label
      };
    });
    return customerList;
  };
}

export const authenticationService = new AuthService();
